import { createSelector } from 'reselect';
import get from 'lodash/get';

const profileSelector = (state) =>
  get(state, 'loginState.status') === 'ready' ? get(state, 'loginState.profile') : {};
const roleIdSelector = (state) => get(state, 'loginState.profile.roleId');
const statusSelector = (state) => get(state, 'loginState.status');

export const getCompanyDetail = createSelector(
  profileSelector,
  ({ companyId, companyMaps = [] }) => {
    if (!!companyMaps) {
      return (
        get(
          companyMaps.filter((c) => get(c, 'companyId') === companyId),
          '0.company'
        ) || get(companyMaps, '0.company')
      );
    }
    return {};
  }
);

export const getProfileHeader = createSelector(
  profileSelector,
  ({ first_name: firstName, last_name: lastName, email, companyMaps = [], companyId }) => {
    const cid = companyId;
    if (!!companyMaps) {
      const companyMap =
        get(
          companyMaps.filter((c) => get(c, 'companyId') === cid),
          '0'
        ) || get(companyMaps, '0', {});

      const {
        company: {
          company_name: companyName,
          companyNameChi,
          logoUrl,
          companyPermission,
          contactPerson,
          contactPersonPhone,
        } = {},
      } = companyMap;
      const username = !!firstName || !!lastName ? [firstName, lastName].join(' ') : null;
      return {
        companyId,
        companyPermission,
        username,
        email,
        companyName: companyName || '',
        companyNameChi: companyNameChi || '',
        logoUrl,
        contactPerson,
        contactPersonPhone,
      };
    }
    return {
      email,
    };
  }
);

export const isFullRequiredDataProfile = createSelector(
  profileSelector,
  ({ email, companyMaps = [], companyId }) => {
    const cid = companyId;
    if (!!companyMaps) {
      const companyMap =
        get(
          companyMaps.filter((c) => get(c, 'companyId') === cid),
          '0'
        ) || get(companyMaps, '0', {});
      const {
        company: { contactPerson, contactPersonPhone, company_name: companyName } = {},
      } = companyMap;

      return !!contactPerson && !!email && !!contactPersonPhone && !!companyName;
    }
    return false;
  }
);

export const getCompanyPermission = createSelector(
  profileSelector,
  (profile) => profile.permissions
);

export const getRoleId = createSelector(roleIdSelector, (roleId) => roleId);

export const checkIfAdminByRoleId = createSelector(
  [profileSelector, roleIdSelector],
  ({ companyMaps = [], companyId }, roleId) => {
    // Define admin role IDs as a constant for better maintainability
    const ADMIN_ROLE_IDS = [3, 4];

    // Check if the provided roleId is an admin role
    return ADMIN_ROLE_IDS.includes(roleId);
  }
);

const haveAdminRole = ({ companyMaps = [], companyId }, roleId) => {
  const isAdminRoleId = [3, 4].includes(roleId);
  return isAdminRoleId;
};
export const checkIfAdmin = createSelector(
  profileSelector,
  roleIdSelector,
  haveAdminRole
  // ({ companyMaps = [], companyId }, roleId) => {
  //   const isAdminRoleId = [3, 4].includes(roleId);

  //   let isAdminCompanyId = false;
  //   if (!!companyMaps) {
  //     isAdminCompanyId =
  //       companyId === 23 && companyMaps.filter((c) => get(c, 'companyId') === 23).length > 0;
  //   }

  //   return isAdminRoleId && isAdminCompanyId;
  // }
);

export const checkIfAli = createSelector(
  [profileSelector, roleIdSelector],
  ({ companyMaps = [] }) => {
    return get(companyMaps, '[0].company.companyPermission.levelOneTestPlanManager');
  }
);

export const checkIfHackedAccount = createSelector(
  [profileSelector, roleIdSelector],
  ({ companyMaps = [], companyId }, roleId) => {
    const isHackedAccountRoleId = [3, 4].includes(roleId);

    let isHackedAccountCompanyId = false;
    if (!!companyMaps) {
      isHackedAccountCompanyId =
        companyId !== 23 && companyMaps.filter((c) => get(c, 'companyId') !== 23).length > 0;
    }

    return isHackedAccountRoleId && isHackedAccountCompanyId;
  }
);

export const isLogin = createSelector(statusSelector, (status) => status === 'ready');
export const isLoginExpired = createSelector(statusSelector, (status) => {
  return status === 'timeOut' || status === 'failed';
});
